import Link from "next/link";

type BookingLinkProps = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  "href"
> & {
  href: string;
  children: React.ReactNode;
};

function isExternalUrl(href: string) {
  return /^(https?:)?\/\//i.test(href);
}

export default function BookingLink({
  href,
  children,
  referrerPolicy,
  rel,
  target,
  ...props
}: BookingLinkProps) {
  const isExternal = isExternalUrl(href);

  if (!isExternal) {
    return (
      <Link href={href} {...props}>
        {children}
      </Link>
    );
  }

  return (
    <a
      href={href}
      target={target ?? "_blank"}
      rel={rel ?? "nofollow noopener"}
      referrerPolicy={referrerPolicy ?? "strict-origin-when-cross-origin"}
      {...props}
    >
      {children}
    </a>
  );
}
